import "../../css/tablePage/TablePage.css"
import {useEffect, useState} from "react";
import TableDateSelector from "./TableDateSelector";
import TableContainer from "./TableContainer";
import TeacherSelector from "../../elements/selector/TeacherSelector";
import TeacherConstant from "../../utils/constants/TeacherConstant";
import {useMediaQuery} from "react-responsive";
import TableWeekController from "./TableWeekController";
import TableControllerAction from "../../utils/constants/TableControllerAction";


let TablePage = (props) => {
    let isMobile = useMediaQuery({maxWidth: 768})

    let defaultStartDate = new Date();
    let defaultEndDate = new Date();

    let dayIndex = defaultStartDate.getDay();
    if (defaultStartDate.getDay() === 0) {
        dayIndex = 7;
    }

    defaultStartDate.setDate(defaultStartDate.getDate() - dayIndex + 1)
    defaultEndDate.setDate(defaultStartDate.getDate() + 6);

    let [startDate, setStartDate] = useState(defaultStartDate);
    let [endDate, setEndDate] = useState(defaultEndDate);
    let [selectedDate, setSelectedDate] = useState(new Date())

    let [teacher, setTeacher] = useState(TeacherConstant.ID_SELECT_ALL);

    useEffect(() => {
        setTeacher(TeacherConstant.ID_SELECT_ALL)
    }, [props.location])

    let onChangeDate = (start, end, select) => {
        setSelectedDate(select)
        setStartDate(start)
        setEndDate(end)
    }
    return (
        <div className="content-container">
            <div className="table-page-header">
                <div className="title-selector-container">
                    <div className="table-page-title-container">
                        <p className="content-title">레슨 시간표</p>
                    </div>
                    <div className="date-selector-container">
                        {isMobile ? null : <TableWeekController
                            action={TableControllerAction.PREVIOUS}
                            startDate={startDate}
                            onChangeDate={onChangeDate.bind(this)}
                            isAdmin={props.isAdmin}
                        />}
                        <TableDateSelector startDate={startDate}
                                           selectedDate={selectedDate}
                                           onChangeDate={onChangeDate.bind(this)}
                                           isAdmin={props.isAdmin}></TableDateSelector>
                        {isMobile ? null : <TableWeekController
                            action={TableControllerAction.NEXT}
                            startDate={startDate}
                            onChangeDate={onChangeDate.bind(this)}
                            isAdmin={props.isAdmin}
                        />}
                        <TeacherSelector data={props.data} currentTeacher={teacher}
                                         onTeacherChange={setTeacher.bind(this)}
                                         location={props.location} short={true}
                                         containsAll={true}
                        ></TeacherSelector>
                    </div>
                </div>
            </div>
            <TableContainer currentTeacher={teacher} data={props.data} startDate={startDate} endDate={endDate}
                            location={props.location} isAdmin={props.isAdmin} myInformation={props.myInformation}
                            setNeedInfoRefresh={props.setNeedInfoRefresh}
                            selectedDate={selectedDate} onChangeDate={onChangeDate.bind(this)}>
            </TableContainer>
        </div>
    );
}
export default TablePage;